


// import { useState, useEffect } from "react";
// import MainLayouts from "../../Layout/MainLayouts";
// import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
// import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
// import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
// import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
// import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
// import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
// import Spinner from "../spinner/Spinner";
// import { Link, useNavigate } from "react-router-dom";
// import { handleError } from "../../components/utils/AuthenticationCheck";
// import { useLocation } from "react-router-dom";
// import CurrencyFormatter from "../../components/utils/CurrencyFormatter";
// import { formatDbDate } from "../../components/utils/DateFormatter";
// import ApiServices from "../../api/ApiServices";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import CustomStyles from "../../components/utils/CustomStyles";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import AxiosApiCall from "../../api/AxiosApiCall";
// import { downloadCSVFromApi } from "../../components/utils/DownlaodCSVFromApi";

// const WalletHistory = () => {
//   const [WalletTransactions, setWalletTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [loadingCSV, setLoadingCSV] = useState(false);
//   const [filterText, setFilterText] = useState("");
//   const [page, setPage] = useState(1);
//   const [perPage, setPerPage] = useState(50);
//   const [totalRows, setTotalRows] = useState(0);

//   // Date filter state
//   const [filters, setFilters] = useState({
//     start_date: "",
//     end_date: "",
//   });

//   const navigate = useNavigate();
//   const location = useLocation();

//   //axios api encryption call
//   const axios = AxiosApiCall();

//   const id = location?.state?.id || null;

//   // Handle filter changes
//   const handleFilterChange = (key, value) => {
//     setFilters((prev) => ({ ...prev, [key]: value }));
//   };

//   // Clear date filters
//   const handleClearDates = () => {
//     setFilters({
//       start_date: "",
//       end_date: "",
//     });
//     toast.success("Date filters cleared");
//   };

//   // Check if both dates are selected
//   const areDatesSelected = filters.start_date && filters.end_date;

//   // ==========================- fetch all WalletTransactions =================
//   useEffect(() => {
//     const fetchAllTransactionList = async () => {
//       setLoading(true);
//       try {
//         const authData = JSON.parse(localStorage.getItem("auth"));
//         const token = authData?.token;
//         if (!token) {
//           throw new Error("No access token found.");
//         }

//         // Prepare payload with filters if dates are selected
//         const payload = {
//           user_id: id,
//           page: page,
//           per_page: perPage
//         };

//         // Add date filters if both are selected
//         if (areDatesSelected) {
//           payload.start_date = filters.start_date;
//           payload.end_date = filters.end_date;
//         }

//         const response = await axios.post(
//           ApiServices.getWalletTransactions,
//           payload,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//             withCredentials: true,
//           }
//         );

//         const { status, message, data } = response.data;
//         if (status === 200) {
//           setWalletTransactions(data.transactions.slice().reverse());
//           setTotalRows(data.total);
//           toast.success(message, { toastId: "Wallet-fetch-successful" });
//         } else {
//           console.log(response);
//           handleError({ response: { status, data: { message } } }, navigate);
//         }
//       } catch (error) {
//         console.log("error", error);
//         handleError(error, navigate);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllTransactionList();
//   // }, [page, perPage, filters.start_date, filters.end_date]); // Add date filters to dependencies
//   }, [page, perPage, filters.start_date, filters.end_date]);
//   // ================================== end of list of customer ==========================================

//   //filter data by name
//   const handleFilter = (e) => {
//     setFilterText(e.target.value);
//   };

//   //handle row change
//   const handleRowChange = (newPerPage) => {
//     setPerPage(newPerPage);
//     setPage(page);
//   };

//   //handle Page Change
//   const handlePageChange = (page) => {
//     setPage(page);
//   };

//   // CSV Download Functionality
//   const handleDownloadCSV = async () => {
//     if (!areDatesSelected) {
//       toast.error("Please select both start and end dates to download CSV");
//       return;
//     }

//     // Validate date range
//     const startDate = new Date(filters.start_date);
//     const endDate = new Date(filters.end_date);

//     if (startDate > endDate) {
//       toast.error("Start date must be before end date");
//       return;
//     }

//     // Limit date range to a year
//     const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
//     if (daysDiff > 365) {
//       toast.error("Date range cannot exceed 1 year");
//       return;
//     }

//     setLoadingCSV(true);

//     try {
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;

//       if (!token) {
//         toast.error("No access token found");
//         return;
//       }

//       // Prepare download payload for wallet transactions
//       const downloadPayload = {
//         // user_id: id,
//         start_date: filters.start_date,
//         end_date: filters.end_date,
//         download: 1, // Indicate this is for download
//       };

//       // Create filename with date range
//       const startDateFormatted = filters.start_date.replace(/-/g, '_');
//       const endDateFormatted = filters.end_date.replace(/-/g, '_');
//       const filename = `wallet_transactions_${startDateFormatted}_to_${endDateFormatted}.csv`;

//       await downloadCSVFromApi(
//         ApiServices.getWalletTransactions, 
//         downloadPayload,
//         token,
//         {
//           filename: filename,
//           navigate: navigate,
//           method: "POST", 
//           useBearerToken: true,
//         }
//       );

//     } catch (error) {
//       console.error("Download error:", error);
//       handleError(error, navigate);
//     } finally {
//       setLoadingCSV(false);
//     }
//   };

//   // Export current page to CSV (existing functionality)
//   // const exportToCSV = () => {
//   //   if (sortedData.length === 0) {
//   //     toast.error("No data to export");
//   //     return;
//   //   }

//   //   // Define headers for your CSV
//   //   const headers = Object.keys(sortedData[0]);

//   //   // Reformat timestamps in the data
//   //   const formattedData = sortedData.map((row) => {
//   //     const newRow = { ...row };
//   //     if (newRow.created_at) {
//   //       newRow.created_at = new Date(newRow.created_at).toLocaleString(
//   //         "en-US",
//   //         {
//   //           year: "numeric",
//   //           month: "2-digit",
//   //           day: "2-digit",
//   //           hour: "2-digit",
//   //           minute: "2-digit",
//   //           second: "2-digit",
//   //           hour12: false,
//   //         }
//   //       );
//   //     }
//   //     return newRow;
//   //   });

//   //   // Combine headers and rows
//   //   const csvRows = [
//   //     headers.join(","),
//   //     ...formattedData.map(
//   //       (row) =>
//   //         headers
//   //           .map((header) => {
//   //             const value = row[header] || "";
//   //             return `"${value.toString().replace(/"/g, '""')}"`;
//   //           })
//   //           .join(",")
//   //     ),
//   //   ];

//   //   // Convert rows to CSV format
//   //   const csv = csvRows.join("\n");

//   //   // Create a Blob from the CSV data
//   //   const csvBlob = new Blob([csv], {
//   //     type: "text/csv;charset=utf-8;",
//   //   });

//   //   // Use FileSaver.js to trigger the download
//   //   saveAs(csvBlob, `WalletTransactions_Page_${page}.csv`);
//   //   toast.success(`Current page (${sortedData.length} records) exported to CSV`);
//   // };

//   const columns = [
//     {
//       name: "Reference",
//       selector: (row) => row.reference,
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Description",
//       sortable: true,
//       width: "200px",
//       cell: (row) => (
//         <div>
//           <span className="block font-bold">
//             {row.description ? row.description.toUpperCase() : "NOT AVAILABLE"}{" "}
//           </span>
//         </div>
//       ),
//     },
//     {
//       name: "Type",
//       selector: (row) =>
//         row.type === "DEBIT" ? (
//           <span className="block font-bold text-red1">Debit</span>
//         ) : (
//           <span className="block font-bold text-darkGreen2">Credit</span>
//         ),
//       sortable: true,
//       width: "120px",
//     },
//     {
//       name: "Amount",
//       selector: (row) => CurrencyFormatter(Number(row.amount)),
//       sortable: true,
//       width: "120px",
//     },
//     {
//       name: "Balance Before",
//       selector: (row) => CurrencyFormatter(Number(row.balance_before)),
//       sortable: true,
//       width: "150px",
//     },
//     {
//       name: "Balance After",
//       selector: (row) => CurrencyFormatter(Number(row.balance_after)),
//       sortable: true,
//       width: "150px",
//     },
//     {
//       name: "Date",
//       selector: (row) => formatDbDate(row.created_at),
//       sortable: true,
//     },
//   ];

//   // Filter data
//   const filteredItems = WalletTransactions.filter((item) => {
//     const matchesFilterText = Object.values(item).some(
//       (value) =>
//         typeof value === "string" &&
//         value.toLowerCase().includes(filterText.toLowerCase())
//     );

//     return matchesFilterText;
//   });

//   const data = filteredItems.map((transaction) => ({
//     created_at: transaction.created_at,
//     description: transaction.description
//       ? transaction.description.toUpperCase()
//       : "NOT AVAILABLE",
//     reference: transaction.reference ? transaction.reference : "NOT AVAILABLE",
//     type: transaction.type ? transaction.type : "NOT AVAILABLE",
//     amount: transaction.amount ? transaction.amount : "NOT AVAILABLE",
//     balance_before: transaction.balance_before
//       ? transaction.balance_before
//       : "NOT AVAILABLE",
//     balance_after: transaction.balance_after
//       ? transaction.balance_after
//       : "NOT AVAILABLE",
//   }));

//   // Sort data based on creation date
//   const sortedData = [...data].sort((a, b) => {
//     const dateA = new Date(a.created_at);
//     const dateB = new Date(b.created_at);
//     return dateB - dateA;
//   });

//   return (
//     <div>
//       <MainLayouts>
//         <div className="sm:rounded-lg py-6 w-full">

//           <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
//             <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//               {/* DESKTOP VERSION (md and up) - Side by side */}
//               <div className="hidden md:flex items-center justify-between">
//                 <div>
//                   <ol className="list-none p-0 inline-flex mb-2">
//                     <li className="flex items-center">
//                       <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                         Customer
//                       </p>
//                       <ChevronRightIcon />
//                     </li>
//                     <li className="flex items-center">
//                       <p className="text-orange1">Wallet Transactions</p>
//                     </li>
//                   </ol>
//                 </div>

//                 <div className="my-2">
//                   <Link
//                     to="/admin/customer/details"
//                     state={{ id }}
//                     className="text-dGrey3 bg-darkGreen3 hover:bg-darkGreen4 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
//                   >
//                     <PlusSquareFill className="mr-2 w-4 h-4" />
//                     Back to Customer Details
//                   </Link>
//                 </div>
//               </div>

//               {/* MOBILE VERSION (below md) - Stacked */}
//               <div className="md:hidden py-3">
//                 <div className="mb-3">
//                   <ol className="list-none p-0 inline-flex items-center">
//                     <li className="flex items-center">
//                       <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                         Customer
//                       </p>
//                       <ChevronRightIcon className="w-4 h-4" />
//                     </li>
//                     <li className="flex items-center">
//                       <p className="text-orange1">Wallets Transactions</p>
//                     </li>
//                   </ol>
//                 </div>

//                 <div className="w-full">
//                   <Link
//                     to="/admin/addproduct"
//                     className="w-full text-dGrey3 bg-darkGreen3 hover:bg-darkGreen4 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-3 text-center inline-flex justify-center items-center"
//                   >
//                     <PlusSquareFill className="mr-2 w-4 h-4" />
//                     Back to Customer Details
//                   </Link>
//                 </div>
//               </div>
//             </nav>
//           </section>

//           {/* Date Filters and Search Section */}
//           <div className="pb-4 bg-white dark:bg-gray-900">
//             {/* DESKTOP FILTERS (md and up) - All in one row */}
//             <div className="hidden md:flex flex-wrap items-center gap-3">
//               <div className="relative flex-grow min-w-[200px]">
//                 <div className="relative">
//                   <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
//                   <input
//                     type="search"
//                     className="block w-full pl-10 pr-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
//                     placeholder="Search ..."
//                     value={filterText}
//                     onChange={handleFilter}
//                   />
//                 </div>
//               </div>

//               <div className="min-w-[150px]">
//                 <div className="relative">
//                   <input
//                     type="date"
//                     value={filters.start_date}
//                     onChange={(e) => handleFilterChange("start_date", e.target.value)}
//                     className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
//                     max={filters.end_date || undefined}
//                     placeholder="Start Date"
//                   />
//                 </div>
//               </div>

//               <div className="min-w-[150px]">
//                 <div className="relative">
//                   <input
//                     type="date"
//                     value={filters.end_date}
//                     onChange={(e) => handleFilterChange("end_date", e.target.value)}
//                     className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
//                     min={filters.start_date || undefined}
//                     placeholder="End Date"
//                   />
//                 </div>
//               </div>

//               {areDatesSelected && (
//                 <div className="min-w-[120px]">
//                   <button
//                     onClick={handleClearDates}
//                     className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800 transition-colors duration-200"
//                   >
//                     <XCircle className="w-4 h-4" />
//                     Clear Dates
//                   </button>
//                 </div>
//               )}

//               <div className="min-w-[160px]">
//                 <button
//                   onClick={handleDownloadCSV}
//                   className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${areDatesSelected
//                     ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
//                     : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                     }`}
//                   disabled={!areDatesSelected || loadingCSV}
//                   title={!areDatesSelected ? "Select start and end dates to enable download" : ""}
//                 >
//                   {loadingCSV ? (
//                     <>
//                       <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
//                       Downloading...
//                     </>
//                   ) : (
//                     <>
//                       <Download className="w-4 h-4" />
//                       Download CSV
//                     </>
//                   )}
//                 </button>
//               </div>
//             </div>

//             {/* MOBILE FILTERS (below md) - Stacked */}
//             <div className="md:hidden flex flex-col gap-3">
//               {/* Search - Full width */}
//               <div className="w-full">
//                 <div className="relative">
//                   <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
//                   <input
//                     type="search"
//                     className="block w-full pl-10 pr-3 py-3 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
//                     placeholder="Search ..."
//                     value={filterText}
//                     onChange={handleFilter}
//                   />
//                 </div>
//               </div>

//               {/* Dates and buttons in a grid on mobile */}
//               <div className="grid grid-cols-2 gap-3">
//                 {/* Start Date */}
//                 <div className="col-span-1">
//                   <div className="relative">
//                     <input
//                       type="date"
//                       value={filters.start_date}
//                       onChange={(e) => handleFilterChange("start_date", e.target.value)}
//                       className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
//                       placeholder="Start"
//                     />
//                   </div>
//                 </div>

//                 {/* End Date */}
//                 <div className="col-span-1">
//                   <div className="relative">
//                     <input
//                       type="date"
//                       value={filters.end_date}
//                       onChange={(e) => handleFilterChange("end_date", e.target.value)}
//                       className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
//                       placeholder="End"
//                     />
//                   </div>
//                 </div>

//                 {/* Clear Dates Button - Full width when shown */}
//                 {areDatesSelected && (
//                   <div className="col-span-2">
//                     <button
//                       onClick={handleClearDates}
//                       className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800"
//                     >
//                       <XCircle className="w-4 h-4" />
//                       Clear Dates
//                     </button>
//                   </div>
//                 )}

//                 {/* Download Button - Full width */}
//                 <div className="col-span-2">
//                   <button
//                     onClick={handleDownloadCSV}
//                     className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-3 text-sm font-semibold ${areDatesSelected
//                       ? "bg-orange1 text-lGrey3 hover:bg-orange-600"
//                       : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                       }`}
//                     disabled={!areDatesSelected || loadingCSV}
//                   >
//                     {loadingCSV ? (
//                       <>
//                         <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
//                         <span className="ml-2">Downloading...</span>
//                       </>
//                     ) : (
//                       <>
//                         <Download className="w-4 h-4" />
//                         <span className="ml-2">Download CSV</span>
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Help text */}
//             <div className="hidden md:flex items-center justify-between mt-2">
//               {!areDatesSelected && (
//                 <p className="text-xs text-gray-500">
//                   Select start and end dates to enable download
//                 </p>
//               )}
//               {areDatesSelected && sortedData.length > 0 && (
//                 <p className="text-sm text-gray-600">
//                   Showing {sortedData.length} records from {filters.start_date} to {filters.end_date}
//                 </p>
//               )}
//             </div>

//             {/* MOBILE help text */}
//             <div className="md:hidden mt-3">
//               {!areDatesSelected && (
//                 <p className="text-xs text-gray-500 text-center mb-2">
//                   Select start and end dates to enable download
//                 </p>
//               )}
//               {areDatesSelected && sortedData.length > 0 && (
//                 <p className="text-sm text-gray-600 text-center">
//                   Showing {sortedData.length} records
//                 </p>
//               )}
//             </div>
//           </div>

//           {/* Action Buttons Row */}
//           <div className="pb-4 bg-white dark:bg-gray-900 flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-4">
//             {/* Download Current Page Button */}
//             {/* <div className="w-full sm:w-1/2">
//               <button
//                 className="w-full bg-darkGreen3 justify-center gap-x-1.5 rounded-md px-3 py-3 text-sm font-semibold text-lGrey3 hover:bg-darkGreen4 transition-colors"
//                 onClick={exportToCSV}
//                 disabled={sortedData.length === 0}
//               >
//                 Download Current Page ({sortedData.length} records)
//               </button>
//             </div> */}

//           </div>

//           {loading ? (
//             <Spinner loading={loading} />
//           ) : (
//             <DataTable
//               columns={columns}
//               progressPending={loading}
//               data={sortedData}
//               pagination
//               paginationServer
//               paginationTotalRows={totalRows}
//               paginationPerPage={perPage}
//               paginationDefaultPage={page}
//               paginationRowsPerPageOptions={[20, 50, 100]}
//               onChangeRowsPerPage={handleRowChange}
//               onChangePage={handlePageChange}
//               highlightOnHover
//               noDataComponent={<div>No wallet transactions found</div>}
//               customStyles={CustomStyles}
//             />
//           )}
//         </div>
//       </MainLayouts>
//     </div>
//   );
// };

// export default WalletHistory;



import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as CheckCircle } from "bootstrap-icons/icons/check-circle.svg";
import Spinner from "../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import { handleError } from "../../components/utils/AuthenticationCheck";
import { useLocation } from "react-router-dom";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";
import { formatDbDate } from "../../components/utils/DateFormatter";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import CustomStyles from "../../components/utils/CustomStyles";
import AxiosApiCall from "../../api/AxiosApiCall";
import { downloadCSVFromApi } from "../../components/utils/DownlaodCSVFromApi";

const WalletHistory = () => {
  const [WalletTransactions, setWalletTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalRows, setTotalRows] = useState(0);

  // Date filter state
  const [tempFilters, setTempFilters] = useState({
    start_date: "",
    end_date: "",
  });

  // Active filters (applied to API)
  const [activeFilters, setActiveFilters] = useState({
    start_date: "",
    end_date: "",
  });

  const navigate = useNavigate();
  const location = useLocation();

  //axios api encryption call
  const axios = AxiosApiCall();

  const id = location?.state?.id || null;

  // Handle temporary filter changes
  const handleTempFilterChange = (key, value) => {
    setTempFilters((prev) => ({ ...prev, [key]: value }));
  };

  // Clear date filters
  const handleClearDates = () => {
    setTempFilters({
      start_date: "",
      end_date: "",
    });
    toast.success("Date filters cleared");
  };

  // Apply filters to fetch data
  const handleApplyFilters = () => {
    if (!tempFilters.start_date || !tempFilters.end_date) {
      toast.error("Please select both start and end dates");
      return;
    }

    // Validate date range
    const startDate = new Date(tempFilters.start_date);
    const endDate = new Date(tempFilters.end_date);

    if (startDate > endDate) {
      toast.error("Start date must be before end date");
      return;
    }

    // Set active filters and trigger API call
    setActiveFilters({ ...tempFilters });
    setPage(1); // Reset to first page when applying new filters
  };

  // Check if both dates are selected in temp filters
  const areDatesSelected = tempFilters.start_date && tempFilters.end_date;

  // Check if both dates are selected in active filters
  const areActiveDatesSelected = activeFilters.start_date && activeFilters.end_date;

  // ==========================- fetch all WalletTransactions =================
  useEffect(() => {
    const fetchAllTransactionList = async () => {
      setLoading(true);
      try {
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) {
          throw new Error("No access token found.");
        }

        // Prepare payload with active filters
        const payload = {
          user_id: id,
          page: page,
          per_page: perPage
        };

        // Add date filters only if they're active (applied)
        if (areActiveDatesSelected) {
          payload.start_date = activeFilters.start_date;
          payload.end_date = activeFilters.end_date;
        }

        const response = await axios.post(
          ApiServices.getWalletTransactions,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            withCredentials: true,
          }
        );

        const { status, message, data } = response.data;
        if (status === 200) {
          setWalletTransactions(data.transactions.slice().reverse());
          setTotalRows(data.total);
          toast.success(message, { toastId: "Wallet-fetch-successful" });
        } else {
          // console.log(response);
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        // console.log("error", error);
        handleError(error, navigate);
      } finally {
        setLoading(false);
      }
    };

    fetchAllTransactionList();
  }, [page, perPage, activeFilters.start_date, activeFilters.end_date]); // Only depend on active filters
  // ================================== end of list of customer ==========================================

  //filter data by name
  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  //handle row change
  const handleRowChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1); // Reset to first page when changing rows per page
  };

  //handle Page Change
  const handlePageChange = (page) => {
    setPage(page);
  };

  // CSV Download Functionality
  const handleDownloadCSV = async () => {
    if (!areActiveDatesSelected) {
      toast.error("Please apply date filters first to download CSV");
      return;
    }

    // Validate date range
    const startDate = new Date(activeFilters.start_date);
    const endDate = new Date(activeFilters.end_date);

    if (startDate > endDate) {
      toast.error("Start date must be before end date");
      return;
    }

    // Limit date range to a year
    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    if (daysDiff > 365) {
      toast.error("Date range cannot exceed 1 year");
      return;
    }

    setLoadingCSV(true);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;

      if (!token) {
        toast.error("No access token found");
        return;
      }

      // Prepare download payload for wallet transactions
      const downloadPayload = {
        user_id: id,
        start_date: activeFilters.start_date,
        end_date: activeFilters.end_date,
        download: 1, 
      };

      // Create filename with date range
      const startDateFormatted = activeFilters.start_date.replace(/-/g, '_');
      const endDateFormatted = activeFilters.end_date.replace(/-/g, '_');
      const filename = `wallet_transactions_${startDateFormatted}_to_${endDateFormatted}.csv`;

      await downloadCSVFromApi(
        ApiServices.getWalletTransactions,
        downloadPayload,
        token,
        {
          filename: filename,
          navigate: navigate,
          method: "POST",
          useBearerToken: true,
        }
      );

    } catch (error) {
      // console.error("Download error:", error);
      handleError(error, navigate);
    } finally {
      setLoadingCSV(false);
    }
  };

  // Clear all filters (both temp and active)
  const handleClearAllFilters = () => {
    setTempFilters({
      start_date: "",
      end_date: "",
    });
    setActiveFilters({
      start_date: "",
      end_date: "",
    });
    toast.success("All filters cleared");
  };

  const columns = [
    {
      name: "Reference",
      selector: (row) => row.reference,
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.description ? row.description.toUpperCase() : "NOT AVAILABLE"}{" "}
          </span>
        </div>
      ),
    },
    {
      name: "Type",
      selector: (row) =>
        row.type === "DEBIT" ? (
          <span className="block font-bold text-red1">Debit</span>
        ) : (
          <span className="block font-bold text-darkGreen2">Credit</span>
        ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Amount",
      selector: (row) => CurrencyFormatter(Number(row.amount)),
      sortable: true,
      width: "120px",
    },
    {
      name: "Balance Before",
      selector: (row) => CurrencyFormatter(Number(row.balance_before)),
      sortable: true,
      width: "150px",
    },
    {
      name: "Balance After",
      selector: (row) => CurrencyFormatter(Number(row.balance_after)),
      sortable: true,
      width: "150px",
    },
    {
      name: "Date",
      selector: (row) => formatDbDate(row.created_at),
      sortable: true,
    },
  ];

  // Filter data locally (client-side)
  const filteredItems = WalletTransactions.filter((item) => {
    const matchesFilterText = Object.values(item).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(filterText.toLowerCase())
    );

    return matchesFilterText;
  });

  const data = filteredItems.map((transaction) => ({
    created_at: transaction.created_at,
    description: transaction.description
      ? transaction.description.toUpperCase()
      : "NOT AVAILABLE",
    reference: transaction.reference ? transaction.reference : "NOT AVAILABLE",
    type: transaction.type ? transaction.type : "NOT AVAILABLE",
    amount: transaction.amount ? transaction.amount : "NOT AVAILABLE",
    balance_before: transaction.balance_before
      ? transaction.balance_before
      : "NOT AVAILABLE",
    balance_after: transaction.balance_after
      ? transaction.balance_after
      : "NOT AVAILABLE",
  }));

  // Sort data based on creation date
  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  return (
    <div>
      <MainLayouts>
        <div className="sm:rounded-lg py-6 w-full">

          <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              {/* DESKTOP VERSION (md and up) - Side by side */}
              <div className="hidden md:flex items-center justify-between">
                <div>
                  <ol className="list-none p-0 inline-flex mb-2">
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Customer
                      </p>
                      <ChevronRightIcon />
                    </li>
                    <li className="flex items-center">
                      <p className="text-orange1">Wallet Transactions</p>
                    </li>
                  </ol>
                </div>

                <div className="my-2">
                  <Link
                    to="/admin/customer/details"
                    state={{ id }}
                    className="text-dGrey3 bg-darkGreen3 hover:bg-darkGreen4 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
                  >
                    <PlusSquareFill className="mr-2 w-4 h-4" />
                    Back to Customer Details
                  </Link>
                </div>
              </div>

              {/* MOBILE VERSION (below md) - Stacked */}
              <div className="md:hidden py-3">
                <div className="mb-3">
                  <ol className="list-none p-0 inline-flex items-center">
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Customer
                      </p>
                      <ChevronRightIcon className="w-4 h-4" />
                    </li>
                    <li className="flex items-center">
                      <p className="text-orange1">Wallets Transactions</p>
                    </li>
                  </ol>
                </div>

                <div className="w-full">
                  <Link
                    to="/admin/customer/details"
                    state={{ id }}
                    className="w-full text-dGrey3 bg-darkGreen3 hover:bg-darkGreen4 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-3 text-center inline-flex justify-center items-center"
                  >
                    <PlusSquareFill className="mr-2 w-4 h-4" />
                    Back to Customer Details
                  </Link>
                </div>
              </div>
            </nav>
          </section>

          {/* Date Filters and Search Section */}
          <div className="pb-4 bg-white dark:bg-gray-900">
            {/* DESKTOP FILTERS (md and up) - All in one row */}
            <div className="hidden md:flex flex-wrap items-center gap-3">
              <div className="relative flex-grow min-w-[200px]">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Search ..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              <div className="min-w-[150px]">
                <div className="relative">
                  <input
                    type="date"
                    value={tempFilters.start_date}
                    onChange={(e) => handleTempFilterChange("start_date", e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    max={tempFilters.end_date || undefined}
                    placeholder="Start Date"
                  />
                </div>
              </div>

              <div className="min-w-[150px]">
                <div className="relative">
                  <input
                    type="date"
                    value={tempFilters.end_date}
                    onChange={(e) => handleTempFilterChange("end_date", e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    min={tempFilters.start_date || undefined}
                    placeholder="End Date"
                  />
                </div>
              </div>

              {/* Apply Filters Button */}
              <div className="min-w-[100px]">
                <button
                  onClick={handleApplyFilters}
                  className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-darkGreen3 rounded-lg hover:bg-darkGreen4 transition-colors duration-200"
                  disabled={!areDatesSelected}
                >
                  <CheckCircle className="w-4 h-4" />
                  Apply
                </button>
              </div>

              {(areDatesSelected || areActiveDatesSelected) && (
                <div className="min-w-[120px]">
                  <button
                    onClick={handleClearAllFilters}
                    className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800 transition-colors duration-200"
                  >
                    <XCircle className="w-4 h-4" />
                    Clear All
                  </button>
                </div>
              )}

              <div className="min-w-[160px]">
                <button
                  onClick={handleDownloadCSV}
                  className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${areActiveDatesSelected
                    ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                  disabled={!areActiveDatesSelected || loadingCSV}
                  title={!areActiveDatesSelected ? "Apply date filters first to enable download" : ""}
                >
                  {loadingCSV ? (
                    <>
                      <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                      Downloading...
                    </>
                  ) : (
                    <>
                      <Download className="w-4 h-4" />
                      Download CSV
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* MOBILE FILTERS (below md) - Stacked */}
            <div className="md:hidden flex flex-col gap-3">
              {/* Search - Full width */}
              <div className="w-full">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-3 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                    placeholder="Search ..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              {/* Dates and buttons in a grid on mobile */}
              <div className="grid grid-cols-2 gap-3">
                {/* Start Date */}
                <div className="col-span-1">
                  <div className="relative">
                    <input
                      type="date"
                      value={tempFilters.start_date}
                      onChange={(e) => handleTempFilterChange("start_date", e.target.value)}
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      placeholder="Start"
                    />
                  </div>
                </div>

                {/* End Date */}
                <div className="col-span-1">
                  <div className="relative">
                    <input
                      type="date"
                      value={tempFilters.end_date}
                      onChange={(e) => handleTempFilterChange("end_date", e.target.value)}
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      placeholder="End"
                    />
                  </div>
                </div>

                {/* Apply Button - Full width */}
                <div className="col-span-2">
                  <button
                    onClick={handleApplyFilters}
                    className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-darkGreen3 rounded-lg hover:bg-darkGreen4"
                    disabled={!areDatesSelected}
                  >
                    <CheckCircle className="w-4 h-4" />
                    Apply Filters
                  </button>
                </div>

                {/* Clear All Button - Full width when shown */}
                {(areDatesSelected || areActiveDatesSelected) && (
                  <div className="col-span-2">
                    <button
                      onClick={handleClearAllFilters}
                      className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800"
                    >
                      <XCircle className="w-4 h-4" />
                      Clear All Filters
                    </button>
                  </div>
                )}

                {/* Download Button - Full width */}
                <div className="col-span-2">
                  <button
                    onClick={handleDownloadCSV}
                    className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-3 text-sm font-semibold ${areActiveDatesSelected
                      ? "bg-orange1 text-lGrey3 hover:bg-orange-600"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    disabled={!areActiveDatesSelected || loadingCSV}
                  >
                    {loadingCSV ? (
                      <>
                        <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                        <span className="ml-2">Downloading...</span>
                      </>
                    ) : (
                      <>
                        <Download className="w-4 h-4" />
                        <span className="ml-2">Download CSV</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Help text */}
            <div className="hidden md:flex items-center justify-between mt-2">
              {!areActiveDatesSelected ? (
                <p className="text-xs text-gray-500">
                  {areDatesSelected
                    ? "Click 'Apply' to filter by dates"
                    : "Select and apply date filters to download CSV"}
                </p>
              ) : (
                <p className="text-sm text-gray-600">
                  Showing {sortedData.length} records from {activeFilters.start_date} to {activeFilters.end_date}
                </p>
              )}
            </div>

            {/* MOBILE help text */}
            <div className="md:hidden mt-3">
              {!areActiveDatesSelected ? (
                <p className="text-xs text-gray-500 text-center mb-2">
                  {areDatesSelected
                    ? "Click 'Apply Filters' to filter by dates"
                    : "Select and apply date filters"}
                </p>
              ) : (
                <p className="text-sm text-gray-600 text-center">
                  Showing {sortedData.length} records
                </p>
              )}
            </div>
          </div>

          {loading ? (
            <Spinner loading={loading} />
          ) : (
            <DataTable
              columns={columns}
              progressPending={loading}
              data={sortedData}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationPerPage={perPage}
              paginationDefaultPage={page}
              paginationRowsPerPageOptions={[20, 50, 100]}
              onChangeRowsPerPage={handleRowChange}
              onChangePage={handlePageChange}
              highlightOnHover
              noDataComponent={
                <div className="py-8 text-center text-gray-500">
                  {areActiveDatesSelected
                    ? "No wallet transactions found in the selected date range"
                    : "No wallet transactions found"}
                </div>
              }
              customStyles={CustomStyles}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default WalletHistory;